import React, { useState } from "react";
import SearchBar from "./components/SearchBar";
import StandPlan from "./components/StandPlan";
import CategoryFilter from "./components/CategoryFilter";
import LanguageSelector from "./components/LanguageSelector";
import ExportView from "./components/ExportView";
import Impressum from "./components/Impressum";
import { LanguageProvider } from "./components/LanguageContext";
import data from "./data/data.json";

function App() {
  const [highlightStands, setHighlightStands] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  return (
    <LanguageProvider>
      <div className="w-full h-screen flex flex-col gap-4 p-4">
        {/* Sprache */}
        <div className="fixed top-4 right-4 z-50 py-2 px-4 rounded bg-white shadow">
          <LanguageSelector />
        </div>

        {/* Volltextsuche */}
        <SearchBar onSelect={setHighlightStands} />

        {/* Kategorieauswahl */}
        <CategoryFilter
          data={data.stands}
          selected={selectedCategories}
          onChange={setSelectedCategories}
          multiSelect
        />

        {/* Standplan */}
        <div  className="hidden export-print:block">
          <StandPlan
            highlightStands={highlightStands}
            selectedCategories={selectedCategories}
          />
        </div>

        {/* PDF Export */}
        <ExportView
          highlightStands={highlightStands}
          selectedCategories={selectedCategories}
          allStands={data.stands}
        />
      </div>
      {/* Impressum */}
      <div>
        <Impressum />
      </div>
    </LanguageProvider>
  );
}

export default App;
